export default "__VITE_ASSET__BgX48JUs__"